//css-------------------
import "@/css/home/qa.scss";




//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";


//npm lib  
import $ from "jquery";
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
            let _this;
            let _c;
            const row = $('.qa_row');
            const head = $('.qa_top');
            const body = $('.qa_bottom');
            head.attr('c', 0);
            body.slideUp(0);
            row.eq(0).find(body).slideDown(0);
            row.eq(0).find(head).attr('c', 1);
            head.click(function (e) {
                e.preventDefault();
                _this = $(this);
                _c = _this.attr('c');
                if (_c == 0) {
                    _this.siblings(body).slideDown();
                    _this.attr('c', 1);
                } else if (_c == 1) {
                    _this.siblings(body).slideUp();
                    _this.attr('c', 0);
                }
            });
        });
    },
    methods: {
        ...baseMethods,
        qa_head_toggle($e) {
            const _this = $($e.target);
            if (_this.attr('c') == 0) {
                _this.siblings('.sidenav').slideDown();
                _this.attr('c', 1);
            } else if (_this.attr('c') == 1) {
                _this.siblings('.sidenav').slideUp();
                _this.attr('c', 0);
            }
        },
    },
}).mount("#app");
